import type { RouteRecordRaw } from 'vue-router'
import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { useLangStore } from '@/stores/langStore'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
  },
  {
    path: '/register-number',
    name: 'register-number',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/RegistrationNumber.vue'),
  },
  {
    path: '/beelive',
    name: 'biometry',
    component: () =>
      import(
        '../views/biometry/BeeLiveView.vue'
      ),
    children: [
      {
        path: '',
        name: 'beelive-instruction',
        redirect: { name: 'instruction' },
      },
      {
        path: '/beelive/instruction',
        name: 'instruction',
        component: () =>
          import(
            '../components/biometry/beelive/BeeLiveInstruction.vue'
          ),
      },
      {
        path: '/beelive/scanner',
        name: 'beelive-scanner',
        component: () =>
          import(
            '../components/biometry/beelive/BeeLiveScanner.vue'
          ),
      },
    ],
  },
  {
    path: '/beedoc',
    name: 'beedoc',
    component: () =>
      import(
        '../views/biometry/BeeDocView.vue'
      ),
    children: [
      {
        path: '',
        name: 'beedoc-instruction',
        redirect: { name: 'beedoc-instruction' },
      },
      {
        path: '/beedoc/instruction',
        name: 'beedoc-instruction',
        component: () =>
          import(
            '../components/biometry/beedoc/BeeDocInstruction.vue'
          ),
      },
      {
        path: '/beedoc/scanner',
        name: 'beedoc-scanner',
        component: () =>
          import(
            '../components/biometry/beedoc/BeeDocScanner.vue'
          ),
      },
    ],
  },
  {
    path: '/status-page',
    name: 'statusPage',
    component: () =>
      import(/* webpackChunkName: "about" */ '../components/StatusView.vue'),
    props: true,
  },
  {
    path: '/loader',
    name: 'loader',
    component: () =>
      import(/* webpackChunkName: "about" */ '../components/LoaderView.vue'),
    props: true,
  },
  {
    path: '/number-registration',
    name: 'number-registration',
    component: () =>
      import(
        '../components/phone-registration/PhoneRegistration.vue'
      ),
    props: true,
  },
  {
    path: '/device-registration',
    name: 'device-registration',
    component: () =>
      import(
        '../components/device-registration/DeviceRegistration.vue'
      ),
    props: true,
  },
  {
    path: '/:lang/number-replacement',
    name: 'number-replacement',
    component: () =>
      import(
        '../views/number-replacement/ReplacementNumberList.vue'
      ),
    props: true,
    meta: { requiresLocalization: true },
  },
  {
    path: '/:lang/number-replacement-payment',
    name: 'number-replacement-payment',
    component: () =>
      import(
        '../components/number-replacement/ReplacementNumbersPayment.vue'
      ),
    props: true,
    meta: { requiresLocalization: true },
  },
  {
    path: '/number-replacement-status',
    name: 'number-replacement-status',
    component: () =>
      import(
        '../components/number-replacement/StatusPage.vue'
      ),
    props: true,
    // meta: { requiresLocalization: true },
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFoundView.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
})

router.beforeEach((to, from, next) => {
  const ctn = to.query.ctn

  const langStore = useLangStore()

  const lang = Array.isArray(to.params.lang)
    ? to.params.lang[0]
    : to.params.lang

  if (to.path === '/' && ctn && ctn.length >= 10) {
    return next('/number-registration')
  }

  if (lang && lang !== langStore.lang) {
    langStore.setSelectedLanguage(lang)
  }

  if (to.meta.requiresLocalization && !lang) {
    const defaultLang = langStore.lang

    return next({
      params: { ...to.params, lang: defaultLang },
      query: to.query,
      hash: to.hash,
    })
  }

  next()
})

export default router
